import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';

const ReferralCodeBox = ({ referralCode }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    if (!referralCode) return;
    navigator.clipboard.writeText(referralCode);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  const hasCode = referralCode && referralCode.trim() !== '';

  return (
    <div className="flex flex-col items-center justify-center min-h-[40vh] p-6">
      <h2 className="text-2xl md:text-3xl font-semibold mb-4 text-center text-gray-800">
        Invite & Earn Rewards
      </h2>

      <div className="bg-white rounded-2xl shadow-xl p-5 w-full max-w-md flex items-center justify-between space-x-4">
        <div className="flex-1">
          <p className="text-gray-600 text-sm mb-1">Your Referral Code:</p>
          <div className={`text-lg md:text-xl font-mono font-semibold break-all ${
            hasCode ? 'text-gray-800' : 'text-red-500 italic'
          }`}>
            {hasCode ? referralCode : 'Invest to generate referral code'}
          </div>
        </div>

        {hasCode && (
          <button
            onClick={handleCopy}
            className="bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-xl transition-all duration-200"
            title="Copy Referral Code"
          >
            {isCopied ? <Check className="w-5 h-5" /> : <Copy className="w-5 h-5" />}
          </button>
        )}
      </div>

      {isCopied && hasCode && (
        <p className="text-green-600 text-sm mt-3 animate-pulse">
          Copied to clipboard!
        </p>
      )}
    </div>
  );
};

export default ReferralCodeBox;
